import { render, staticRenderFns } from "./WhereMyTruckRow.vue?vue&type=template&id=4aa92242&"
import script from "./WhereMyTruckRow.vue?vue&type=script&lang=ts&"
export * from "./WhereMyTruckRow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports